import {makeObservable} from "mobx";
import {ApolloClient} from "@apollo/client";
import {MobxSubmissionStore} from "./MobxSubmissionStore";
import {ContestStore} from "./ContestStore";

export class RootStore {

  submissionStore: MobxSubmissionStore;
  contestStore: ContestStore;

  constructor(client: ApolloClient<any>, contestStore: ContestStore, user: string, userName: string) {
    this.contestStore = contestStore

    if (this.contestStore)
      this.submissionStore = new MobxSubmissionStore(client, user, userName, this.contestStore)

    makeObservable(this, {})
  }
}

